<template>


    <div class="pc">

        <div id="heaher" class="item">
            <div class="inner wl">
                <div class="logo">
                    <a href="" title="寓小未 - 公寓管理系统、长租公寓系统、公寓系统、出租房管理软件">
                        <img class="logo1" src="../../public/picture/logo.png"></a>
                </div>
                <div class="headnav" id="navigate">
                    <button class="login" @click="login()" type="登录">登录</button>
                    <button class="trial" @click="trial()" type="免费试用">免费试用</button>
                </div>
            </div>
        </div>

        <div class="block-top">
            <div class="block-content">
                <div class="left">
                    <h2 class="block-title">公寓管理系统数字生态引领者</h2>
                    <div class="interval" style="height: 1px"></div>
                    <h3 class="block-sub-title">科技助推改革引擎，匠心助力降本增效，寓以致用 信以为本</h3>
                    <div class="interval" style="height: 1px"></div>
                    <p class="block-text">致力为长租公寓运营商提供运营管理、智能设备、招租导流、 安全交易的整体解决方案，助力公寓数字化转型。</p>
                    <div class="interval" style="height: 1px"></div>
                    <button class="free-sign" @click="freesign()">人工咨询</button>
                </div>
                <div class="right">
                    <img src="../../public/picture/f966a38e-0780-40be-bb52-5699d13cb3d9.png">
                </div>
            </div>
        </div>

        <div class="block-2">
            <div class="block-content">
                <div class="text-center">
                    <h2 class="block-title small">行业挑战</h2>
                    <div class="interval" style="height: 1px"></div>
                </div>
                <div class="no1"></div>
                <ul>
                    <li>
                        <div>
                            <img src="../../public/picture/little-logo1.png" width="48" height="48">
                            <h1 class="top">抄表成本高</h1>
                            <p class="text">线下人工现场抄表，费时费力，信息管理维护难，易出错</p>
                        </div>
                    </li>
                    <li>
                        <div>
                            <img src="../../public/picture/little-logo2.png" width="48" height="48">
                            <h1 class="top">智能化程度低</h1>
                            <p class="text">硬件设备与软件平台无法打通，硬件未上云，无法智能化管理</p>
                        </div>
                    </li>
                    <li>
                        <div>
                            <img src="../../public/picture/little-logo3.png" width="48" height="48">
                            <h1 class="top">人员管理难</h1>
                            <p class="text">租客访客通行场景众多，管理繁琐，安全易出漏洞</p>
                        </div>
                    </li>
                    <li>
                        <div>
                            <img src="../../public/picture/little-logo4.png" width="48" height="48">
                            <h1 class="top">风险预防难</h1>
                            <p class="text">室内室外突发意外情况难以及时发现响应，风险应对被动难防</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="block-3">
            <div class="block-content">
                <div class="text-center">
                    <h2 class="block-title small">公寓运营的数字化管理工具</h2>
                    <div class="interval" style="height: 1px"></div>
                    <p class="block-text">助推公寓智能化、精细化管理，提升住户租住体验, 一远程授权，以节省费用。</p>
                </div>
                <div class="intro">
                    <div class="left">
                        <ul>
                            <li key="1" class="active"><h3 class="title">
                                <img class="icon" alt="">统一平台管理
                            </h3>
                                <p class="block-text">软硬件一体化平台，实现数据互联互通； 设备联网上云，实现场景化、智能化管控</p></li>
                            <li key="2"><h3 class="title">
                                <img class="icon" alt="">批量在线抄表
                            </h3>
                                <p class="block-text">在线化批量多楼栋一键抄表，避免了大量的人力资源浪费， 降低人工成本；灵活的自定义能耗分析，指导业务精准优化</p></li>
                            <li key="3"><h3 class="title">
                                <img class="icon" alt="">安全通行管控
                            </h3>
                                <p class="block-text">智能化门禁系统，灵活的权限管控，多类型通行方式， 租客、访客分类管理，保障居住安全</p></li>
                            <li key="4"><h3 class="title">
                                <img class="icon" alt="">设备实时告警
                            </h3>
                                <p class="block-text">智能化设备告警配置，燃气报警、烟雾报警、人体感应、 门锁告警等，实现事前预警、事中报警、事后追溯</p></li>
                        </ul>
                    </div>
                    <div class="intro-images">
                        <img src="../../public/picture/0a3b3288-3446-4420-bbff-f263d0c02d8e.png" alt="1"
                             style="display: block;">
                        <img src="../../public/picture/a53a4e6a-3b83-4044-87f9-9d49b30a8fdc.png" alt="2">
                        <img src="../../public/picture/ef2b73f2-75d1-4d3a-beea-22da0e1421bd.png" alt="3">
                        <img class="img4" src="../../public/picture/ee04a05a-1230-46b6-8ad5-1a95b140fff3.png" alt="4">
                    </div>
                </div>
            </div>
        </div>

        <div class="block-4">
            <div class="block-content">
                <div class="text-center">
                    <h2 class="block-title small">发展17年，覆盖中国公寓SaaS市场</h2>
                </div>
                <div class="no1"></div>
                <ul>
                    <li>
                        <div class="top small"><span>10</span>
                            <span class="span1">城</span>
                        </div>
                        <div class="text">本地服务</div>
                    </li>
                    <li>
                        <div class="top"><span>25,000</span>
                            <span class="span1">+</span>
                        </div>
                        <div class="text">公寓用户</div>
                    </li>
                    <li>
                        <div class="top"><span>50</span>
                            <span class="span1">+</span>
                        </div>
                        <div class="text">覆盖城市</div>
                    </li>
                </ul>
                <ul>
                    <li>
                        <div class="top small"><span>2</span>
                            <span class="span1">年</span>
                        </div>
                        <div class="text">质保售后</div>
                    </li>
                    <li>
                        <div class="top"><span>180</span>
                            <span class="span1">+</span>
                        </div>
                        <div class="text">顾问团队</div>
                    </li>
                    <li>
                        <div class="top"><span>7x24</span>
                            <span class="span1">h</span>
                        </div>
                        <div class="text">在线服务</div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="block-5">
            <div class="block-content">
                <div class="text-center">
                    <h2 class="block-title small">小未严选，提供软硬件整体解决方案</h2>
                    <div class="interval" style="height: 1px"></div>
                    <p class="block-text">全场景智慧交互升级，打造智能化租住体验</p>
                </div>
                <div class="imgs">
                    <img src="../../public/picture/0f4bd884-dc9c-4cf9-b59e-7d5958fec3dd.png">
                </div>
            </div>
        </div>

        <div class="block-6">
            <div class="block-content">
                <div class="text-center">
                    <h2 class="block-title small">为什么选择我们</h2>
                    <div class="interval" style="height: 1px"></div>
                    <p class="block-text">全场景智慧交互升级，打造智能化租住体验</p>
                </div>
                <ul>
                    <li>
                        <div class="div-cen">
                            <div class="top">降本增效</div>
                            <p class="text">软硬件一体化运营平台，全流程在线化管理，依托智能化设备，实现人房比提升150%，公区能耗降低80%。</p>
                        </div>
                    </li>
                    <li>
                        <div class="div-cen">
                            <div class="top">品质保障</div>
                            <p class="text">丰富的安全应用，智能门锁门禁、公区安防、设备告警，灵活严格的权限管控，保障居住安全。</p>
                        </div>
                    </li>
                    <li>
                        <div class="div-cen">
                            <div class="top">持续更新</div>
                            <p class="text">在空置、带看、收租、监管、安全等环节，我们持续保持研发更新，从产品端为用户解决问题。</p>
                        </div>
                    </li>
                    <li>
                        <div class="div-cen">
                            <div class="top">一站式服务</div>
                            <p class="text">由专业团队提供多对1专属服务，对用户提出的任何问题事事有回应，速度给出解决方案。</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="block-7">
            <div class="block-content">
                <div class="text-center">
                    <h2 class="block-title small">强大硬件生态 让生活更简单</h2>
                    <div class="interval" style="height: 1px"></div>
                    <p class="block-text">全场景智慧交互升级，打造差异化租住体验</p>
                </div>
                <div class="imgs">
                    <img src="../../public/picture/0f252364-a561-4e8d-8065-9a6797a6b1d3.png">
                </div>
                <div class="focus" id="div1">
                    <ul>
                        <li><img src="../../public/picture/appliances/2a2e9d66-b41d-4645-87bd-95f2cfeed218.png">
                        </li>
                        <li><img src="../../public/picture/appliances/2a50628e-7758-4c51-9fbb-d37c61cdacad.png">
                        </li>
                        <li><img src="../../public/picture/appliances/2e96a7e3-affb-438e-b7c3-e1430df425c9.png">
                        </li>
                        <li><img src="../../public/picture/appliances/3fabb83a-1c09-4fd9-892b-4ef7457daafa.png">
                        </li>
                        <li><img src="../../public/picture/appliances/5b8d2da3-3744-4bb3-acdc-329056b8259d.png">
                        </li>
                        <li><img src="../../public/picture/appliances/8dcfda14-5712-4d28-82f7-ae905b3c2308.png">
                        </li>
                        <li><img src="../../public/picture/appliances/9ec6fc2d-50d2-422e-b954-de87dcd04198.png">
                        </li>
                        <li><img src="../../public/picture/appliances/057dd338-e487-4bbc-a74c-0384c44a9ca3.png">
                        </li>
                        <li><img src="../../public/picture/appliances/583df4b7-a159-4cfc-9543-4f666120b25f.png">
                        </li>
                        <li><img src="../../public/picture/appliances/740c79ce-af29-41b8-b78d-5f49c96e38c4.png">
                        </li>
                        <li><img src="../../public/picture/appliances/00874a5e-0df2-446b-8f69-a30eb7d88ee8.png">
                        </li>
                        <li><img src="../../public/picture/appliances/1405081e-f545-42e1-86a2-f7559ae2e276.png">
                        </li>
                        <li><img src="../../public/picture/appliances/2a2e9d66-b41d-4645-87bd-95f2cfeed218.png">
                        </li>
                        <li><img src="../../public/picture/appliances/2a50628e-7758-4c51-9fbb-d37c61cdacad.png">
                        </li>
                        <li><img src="../../public/picture/appliances/2e96a7e3-affb-438e-b7c3-e1430df425c9.png">
                        </li>
                        <li><img src="../../public/picture/appliances/3fabb83a-1c09-4fd9-892b-4ef7457daafa.png">
                        </li>
                        <li><img src="../../public/picture/appliances/5b8d2da3-3744-4bb3-acdc-329056b8259d.png">
                        </li>
                        <li><img src="../../public/picture/appliances/8dcfda14-5712-4d28-82f7-ae905b3c2308.png">
                        </li>
                        <li><img src="../../public/picture/appliances/9ec6fc2d-50d2-422e-b954-de87dcd04198.png">
                        </li>
                        <li><img src="../../public/picture/appliances/057dd338-e487-4bbc-a74c-0384c44a9ca3.png">
                        </li>
                        <li><img src="../../public/picture/appliances/583df4b7-a159-4cfc-9543-4f666120b25f.png">
                        </li>
                        <li><img src="../../public/picture/appliances/740c79ce-af29-41b8-b78d-5f49c96e38c4.png">
                        </li>
                        <li><img src="../../public/picture/appliances/00874a5e-0df2-446b-8f69-a30eb7d88ee8.png">
                        </li>
                        <li><img src="../../public/picture/appliances/1405081e-f545-42e1-86a2-f7559ae2e276.png">
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="block-8" style="display: block;">
            <div class="block-content8" style="display: flex;">
                <div class="left">
                    <img class="img1" src="../../public/picture/1fdbfbf3-1d86-4b29-a3fc-46345852f2f8.png" width="50%">
                </div>
                <div class="right">
                    <h2 class="block-title">即刻开启您的物联网之旅</h2>
                    <button class="free-sign" @click="freesign()">立即体验</button>
                </div>
            </div>
         
        </div>
        <div style="height: 50px; text-align: center;font-size: 18px;padding: 0 20px; line-height: 50px;" >Copyright @ 2020-2023 小未科技（珠海）有限公司版权所有
          <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2022015676号-2</a></div>
        
    </div>

    <div class="mobile">

        <div class="block-top">
            <div class="head-nav">
                <div class="logo">
                    <a href="" title="寓小未 - 公寓管理系统、长租公寓系统、公寓系统、出租房管理软件">
                        <img class="logo1" src="../../public/picture/logo.png"></a>
                </div>
                <div class="right">
                    <i class="icon-menu" @click="menu()"  type="更多"></i>
                    <i class="icon-del" @click="del()" type="更多"></i>
                </div>
            </div>
        </div>

        <div class="header-dropdown">
            <div class="header-dropdown-mask" @click="f3()"></div>
            <div class="header-dropdown-container">
                <div class="header-item1"></div>
                <div class="header-item" @click="login()">
                    <span>登录</span>
                </div>
                <div class="header-item" @click="trial()">
                    <span>免费试用</span>
                </div>
            </div>
        </div>

        <div class="block-2">
            <div class="top">
                <h2 class="block-title">寓小未<br>
                    公寓管理系统数字生态引领者</h2>
                <div class="interval" style="height: 1px"></div>
                <h3 class="block-sub-title">科技助推改革引擎，匠心助力降本增效，寓以致用 信以为本</h3>
                <div class="interval" style="margin-top: 20px">
                    <button class="free-sign" @click="freesign()">免费试用</button>
                </div>
            </div>
            <div class="img1">
                <img src="../../public/picture/f966a38e-0780-40be-bb52-5699d13cb3d9.png">
            </div>
        </div>

        <div class="block-3">
            <div class="top">
                <h2 class="block-title small">行业挑战</h2>
                <div class="interval" style="height: 1px"></div>
            </div>
            <div class="no1"></div>
            <div class="bottom">
                <ul>
                    <li>
                        <img src="../../public/picture/little-logo1.png">
                        <div>
                            <h1 class="top">抄表成本高</h1>
                            <p class="text">线下人工现场抄表，费时费力，信息管理维护难，易出错</p>
                        </div>
                    </li>
                    <li>
                        <img src="../../public/picture/little-logo2.png">
                        <div>
                            <h1 class="top">智能化程度低</h1>
                            <p class="text">硬件设备与软件平台无法打通，硬件未上云，无法智能化管理</p>
                        </div>
                    </li>
                    <li>
                        <img src="../../public/picture/little-logo3.png">
                        <div>
                            <h1 class="top">人员管理难</h1>
                            <p class="text">租客访客通行场景众多，管理繁琐，安全易出漏洞</p>
                        </div>
                    </li>
                    <li>
                        <img src="../../public/picture/little-logo4.png">
                        <div>
                            <h1 class="top">风险预防难</h1>
                            <p class="text">室内室外突发意外情况难以及时发现响应，风险应对被动难防</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="block-4">
            <h2 class="block-title small">公寓运营的数字化管理工具</h2>
            <div class="interval" style="height: 1px"></div>
            <p class="block-text">助推公寓智能化、精细化管理，提升住户租住体验, 一远程授权，以节省费用。</p>
        </div>

        <div class="block-4-list item1">
            <h2 class="block-title small">统一平台管理</h2>
            <div class="interval" style="height: 1px"></div>
            <p class="block-text">软硬件一体化平台，实现数据互联互通； 设备联网上云，实现场景化、智能化管控</p>
            <div class="imgs">
                <img src="../../public/picture/0a3b3288-3446-4420-bbff-f263d0c02d8e.png">
            </div>
        </div>

        <div class="block-4-list item2">
            <h2 class="block-title small">批量在线抄表</h2>
            <div class="interval" style="height: 1px"></div>
            <p class="block-text">在线化批量多楼栋一键抄表，避免了大量的人力资源浪费， 降低人工成本；灵活的自定义能耗分析，指导业务精准优化</p>
            <div class="imgs">
                <img src="../../public/picture/a53a4e6a-3b83-4044-87f9-9d49b30a8fdc.png">
            </div>
        </div>

        <div class="block-4-list item3">
            <h2 class="block-title small">安全通行管控</h2>
            <div class="interval" style="height: 1px"></div>
            <p class="block-text">智能化门禁系统，灵活的权限管控，多类型通行方式， 租客、访客分类管理，保障居住安全</p>
            <div class="imgs">
                <img src="../../public/picture/ef2b73f2-75d1-4d3a-beea-22da0e1421bd.png">
            </div>
        </div>

        <div class="block-4-list item4">
            <h2 class="block-title small">设备实时告警</h2>
            <div class="interval" style="height: 1px"></div>
            <p class="block-text">智能化设备告警配置，燃气报警、烟雾报警、人体感应、 门锁告警等，实现事前预警、事中报警、事后追溯</p>
            <div class="imgs">
                <img class="img4" src="../../public/picture/ee04a05a-1230-46b6-8ad5-1a95b140fff3.png">
            </div>
        </div>

        <div class="block-5">
            <div class="top">
                <h2 class="block-title small">发展17年，覆盖中国公寓SaaS市场</h2>
            </div>
            <div class="no1"></div>
            <div class="bottom">
                <ul>
                    <li>
                        <div class="top small"><span>10</span>
                            <span class="span1">城</span>
                        </div>
                        <div class="text">本地服务</div>
                    </li>
                    <li>
                        <div class="top"><span>25,000</span>
                            <span class="span1">+</span>
                        </div>
                        <div class="text">公寓用户</div>
                    </li>
                    <li>
                        <div class="top"><span>50</span>
                            <span class="span1">+</span>
                        </div>
                        <div class="text">覆盖城市</div>
                    </li>
                    <li>
                        <div class="top small"><span>2</span>
                            <span class="span1">年</span>
                        </div>
                        <div class="text">质保售后</div>
                    </li>
                    <li>
                        <div class="top"><span>180</span>
                            <span class="span1">+</span>
                        </div>
                        <div class="text">顾问团队</div>
                    </li>
                    <li>
                        <div class="top"><span>7x24</span>
                            <span class="span1">h</span>
                        </div>
                        <div class="text">在线服务</div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="block-6">
            <div class="top">
                <h2 class="block-title small">小未严选，提供软硬件整体解决方案</h2>
                <div class="interval" style="height: 1px"></div>
                <p class="block-text">全场景智慧交互升级，打造智能化租住体验</p>
            </div>
            <div class="bottom">
                <img src="../../public/picture/0f4bd884-dc9c-4cf9-b59e-7d5958fec3dd.png">
            </div>
        </div>

        <div class="block-7">
            <div class="top">
                <h2 class="block-title small">为什么选择我们</h2>
                <div class="interval" style="height: 1px"></div>
                <p class="block-text">全场景智慧交互升级，打造智能化租住体验</p>
            </div>
            <div class="bottom">
                <ul>
                    <li>
                        <img src="../../public/picture/b8e80fa3-20f9-4fb1-aa28-80dbacb73b30.png">
                        <div class="div-cen">
                            <div class="top">降本增效</div>
                            <p class="text">软硬件一体化运营平台，全流程在线化管理，依托智能化设备，实现人房比提升150%，公区能耗降低80%。</p>
                        </div>
                    </li>
                    <li>
                        <img src="../../public/picture/1405081e-f545-42e1-86a2-f7559ae2e276.png">
                        <div class="div-cen">
                            <div class="top">品质保障</div>
                            <p class="text">丰富的安全应用，智能门锁门禁、公区安防、设备告警，灵活严格的权限管控，保障居住安全。</p>
                        </div>
                    </li>
                    <li>
                        <img src="../../public/picture/00874a5e-0df2-446b-8f69-a30eb7d88ee8.png">
                        <div class="div-cen">
                            <div class="top">持续更新</div>
                            <p class="text">在空置、带看、收租、监管、安全等环节，我们持续保持研发更新，从产品端为用户解决问题。</p>
                        </div>
                    </li>
                    <li>
                        <img src="../../public/picture/740c79ce-af29-41b8-b78d-5f49c96e38c4.png">
                        <div class="div-cen">
                            <div class="top">一站式服务</div>
                            <p class="text">由专业团队提供多对1专属服务，对用户提出的任何问题事事有回应，速度给出解决方案。</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="block-8">
            <div class="top">
                <h2 class="block-title small">强大硬件生态 让生活更简单</h2>
                <div class="interval" style="height: 1px"></div>
                <p class="block-text">全场景智慧交互升级，打造差异化租住体验</p>
            </div>
            <div class="imgs">
                <img src="../../public/picture/0f252364-a561-4e8d-8065-9a6797a6b1d3.png">
            </div>
            <div class="focus" id="div9">
                <ul>
                    <li><img src="../../public/picture/appliances/2a2e9d66-b41d-4645-87bd-95f2cfeed218.png">
                    </li>
                    <li><img src="../../public/picture/appliances/2a50628e-7758-4c51-9fbb-d37c61cdacad.png">
                    </li>
                    <li><img src="../../public/picture/appliances/2e96a7e3-affb-438e-b7c3-e1430df425c9.png">
                    </li>
                    <li><img src="../../public/picture/appliances/3fabb83a-1c09-4fd9-892b-4ef7457daafa.png">
                    </li>
                    <li><img src="../../public/picture/appliances/5b8d2da3-3744-4bb3-acdc-329056b8259d.png">
                    </li>
                    <li><img src="../../public/picture/appliances/8dcfda14-5712-4d28-82f7-ae905b3c2308.png">
                    </li>
                    <li><img src="../../public/picture/appliances/9ec6fc2d-50d2-422e-b954-de87dcd04198.png">
                    </li>
                    <li><img src="../../public/picture/appliances/057dd338-e487-4bbc-a74c-0384c44a9ca3.png">
                    </li>
                    <li><img src="../../public/picture/appliances/583df4b7-a159-4cfc-9543-4f666120b25f.png">
                    </li>
                    <li><img src="../../public/picture/appliances/740c79ce-af29-41b8-b78d-5f49c96e38c4.png">
                    </li>
                    <li><img src="../../public/picture/appliances/00874a5e-0df2-446b-8f69-a30eb7d88ee8.png">
                    </li>
                    <li><img src="../../public/picture/appliances/1405081e-f545-42e1-86a2-f7559ae2e276.png">
                    </li>
                    <li><img src="../../public/picture/appliances/2a2e9d66-b41d-4645-87bd-95f2cfeed218.png">
                    </li>
                    <li><img src="../../public/picture/appliances/2a50628e-7758-4c51-9fbb-d37c61cdacad.png">
                    </li>
                    <li><img src="../../public/picture/appliances/2e96a7e3-affb-438e-b7c3-e1430df425c9.png">
                    </li>
                    <li><img src="../../public/picture/appliances/3fabb83a-1c09-4fd9-892b-4ef7457daafa.png">
                    </li>
                    <li><img src="../../public/picture/appliances/5b8d2da3-3744-4bb3-acdc-329056b8259d.png">
                    </li>
                    <li><img src="../../public/picture/appliances/8dcfda14-5712-4d28-82f7-ae905b3c2308.png">
                    </li>
                    <li><img src="../../public/picture/appliances/9ec6fc2d-50d2-422e-b954-de87dcd04198.png">
                    </li>
                    <li><img src="../../public/picture/appliances/057dd338-e487-4bbc-a74c-0384c44a9ca3.png">
                    </li>
                    <li><img src="../../public/picture/appliances/583df4b7-a159-4cfc-9543-4f666120b25f.png">
                    </li>
                    <li><img src="../../public/picture/appliances/740c79ce-af29-41b8-b78d-5f49c96e38c4.png">
                    </li>
                    <li><img src="../../public/picture/appliances/00874a5e-0df2-446b-8f69-a30eb7d88ee8.png">
                    </li>
                    <li><img src="../../public/picture/appliances/1405081e-f545-42e1-86a2-f7559ae2e276.png">
                    </li>
                </ul>
            </div>
        </div>

        <div class="block-9" >
            <div class="left">
                <img class="img1" src="../../public/picture/1fdbfbf3-1d86-4b29-a3fc-46345852f2f8.png" width="50%">
            </div>
            <div class="right">
                <h2 class="block-title">即刻开启您的物联网之旅</h2>
                <button class="free-sign" onclick="freesign()">立即体验</button>
            </div>
         
        </div>
      
        <div style="text-align: center;font-size: 14px;padding: 0 20px; line-height: 25px; height: 50px;" >Copyright @ 2020-2023 小未科技（珠海）有限公司版权所有
           <br> <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2022015676号-2</a></div>

    </div>
   <!--  Copyright @ 2019-2023 Company name All rights reserved. 粤ICP备2022015676号 粤公网安备44040202001307号 -->
    


</template>

<script>
import "../../public/js/index.min"

export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  methods: {
      menu(){
          let more = document.querySelectorAll(".block-top .right i");
          let dropdown = document.querySelectorAll(".mobile .header-dropdown");

          more[0].style.display = 'none';
          more[1].style.display = 'block';
          dropdown[0].className = 'header-dropdown-show';
      },
      del(){
          let more = document.querySelectorAll(".block-top .right i");
          let dropdown1 = document.querySelectorAll(".mobile .header-dropdown-show");

          more[1].style.display = 'none';
          more[0].style.display = 'block';
          dropdown1[0].className = 'header-dropdown';
      },
      f3(){
          let dropdown = document.querySelectorAll(".mobile .header-dropdown-show");
          let more = document.querySelectorAll(".block-top .right i");
          more[1].style.display = 'none';
          more[0].style.display = 'block';
          dropdown[0].className = 'header-dropdown';
      },
      login(){
          window.open('https://a.smartxwei.com/');
      },
      trial(){
          window.open('https://a.smartxwei.com/');
      },
      freesign(){
          window.open('https://a.smartxwei.com/');
      }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @import "../../public/css/base.css";
</style>
